export default "__VITE_ASSET__074a1f27__"